export * from './create-edit-sector.component';
export * from './create-edit-sector.dialog';
export * from './sectors.component';
export * from './sectors.trans';
export * from './sectors';
